<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>404</h1>
        <p>Strona nie istnieje.</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NotFoundPage',
};
</script>
